$(document).ready(function () { 
//   if($('.form-message.form-message--success').is(":visible")){
//     $("html, body").animate({scrollTop: 0}, 1000);
//   }
  $('#SubscribeBtn').click(function(){
    var FooterEmailVal = $('#ContactFooter-email').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(FooterEmailVal.trim() != ''){
    	$('#ContactFooter').submit();
    } else if(!pattern.test(FooterEmailVal)){
      if(FooterEmailVal.trim() == ''){
        $('.emailError').show();
        $('.emailError').html('Enter Email id');
        $('#ContactFooter-email').attr('aria-invalid','true');
        $('#ContactFooter-email').attr('aria-describedby','ContactFooter-email-error');
        $('#ContactFooter-email').addClass('input--error');
      } else{
         $('.emailError').show();
         $('.emailError').html('Enter Valid Email Address');
         $('#ContactFooter-email').attr('aria-invalid','true');
         $('#ContactFooter-email').attr('aria-describedby','ContactFooter-email-error');
         $('#ContactFooter-email').addClass('input--error');
      }
    }
//     $('#ContactFooter').submit();
// 	 $('#ContactFooter').validate({
//       rules: {                   
//         "contact[email]": {
//           required: true,
//           email: true,
//         }
//       },
//       messages: {        
//         "contact[email]":{
//         	required: 'Email field is required',
//           	email : 'Enter a valid email'
//         }
//       },
//       submitHandler: function(form) {
//         this.submit();
//       }
//     });
  })
  
  $('#customer_login').validate({
      rules: {                   
        "customer[email]": {
          required: true,
          email: true,
        },
        "customer[password]": {
          required: true          
        }
      },
      messages: {        
        "customer[email]":{
        	required: 'Email field is required',
          	email : 'Enter a valid email'
        },
        "customer[password]": {
          required: 'Password field is required'
        }
      },
      submitHandler: function(form) {
        this.submit();
      }
    });
  //Rercover passsword
  $('#passwordRecover').validate({
      rules: {                   
        "email": {
          required: true,
          email: true,
        }
      },
      messages: {        
        "email":{
        	required: 'Email field is required',
          	email : 'Enter a valid email'
        }
      },
      submitHandler: function(form) {
        this.submit();
      }
    });
  //register
   $('#RegisterForm').validate({
      rules: {       
        "customer[first_name]":{
          required: true
        },
        "customer[last_name]":{
          required: true
        },
        "customer[email]": {
          required: true,
          email: true,
        },
        "customer[password]": {
          required: true          
        }
      },
      messages: {  
        "customer[first_name]":{
          required: 'First name field is required'
        },
        "customer[last_name]":{
          required: 'Last name field is required',
          
        },
        "customer[email]":{
        	required: 'Email field is required',
          	email : 'Enter a valid email'
        },
        "customer[password]": {
          required: 'Password field is required'
        }
      },
      submitHandler: function(form) {
        this.submit();
      }
    });
  
//Add new Addresses
  $.validator.addMethod("valueNotEquals", function(value, element, arg){
  return arg !== value;
 }, "Value must not equal arg.");
 $('#address_form_new').validate({
      rules: {       
        "address[company]":{
          required: true
        },
        "address[first_name]":{
          required: true
        },
        "address[last_name]":{
          required: true
        },
        "address[address1]":{
          required: true
        },
        "address[address2]":{
          required: true
        },
        "address[zip]":{
          required: true
        },
        "address[country]":{
          valueNotEquals: '---'
        },
        "address[province]":{
          required: true
        },
        "address[city]":{
          required: true
        },
        "address[phone]":{
          required: true
        }
        
      },
      messages: {  
        "address[company]":{
          required: 'Company field is required'
        },
        "address[first_name]":{
          required: 'First name field is required'
        },
        "address[last_name]":{
          required: 'Last name field is required',          
        },
        "address[address1]":{
          required: 'Address1 field is required',          
        },
        "address[address2]":{
          required: 'Address2 field is required',          
        },
        "address[zip]":{
          required: 'Zip field is required',          
        },
        "address[country]":{
          valueNotEquals: 'Country field is required',          
        },
        "address[province]":{
          required: 'Province field is required',          
        },
        "address[city]":{
          required: 'City field is required',          
        },
        "address[phone]":{
          required: 'Phone field is required',          
        }        
      },
      submitHandler: function(form) {
        this.submit();
      }
    });
  //Edit Address
   $.validator.addMethod("valueNotEquals", function(value, element, arg){
  return arg !== value;
 }, "Value must not equal arg.");
 $('.EditAddress form').validate({
      rules: {       
        "address[company]":{
          required: true
        },
        "address[first_name]":{
          required: true
        },
        "address[last_name]":{
          required: true
        },
        "address[address1]":{
          required: true
        },
        "address[address2]":{
          required: true
        },
        "address[zip]":{
          required: true
        },
        "address[country]":{
          valueNotEquals: '---'
        },
        "address[province]":{
          required: true
        },
        "address[city]":{
          required: true
        },
        "address[phone]":{
          required: true
        }
        
      },
      messages: {  
        "address[company]":{
          required: 'Company field is required'
        },
        "address[first_name]":{
          required: 'First name field is required'
        },
        "address[last_name]":{
          required: 'Last name field is required',          
        },
        "address[address1]":{
          required: 'Address1 field is required',          
        },
        "address[address2]":{
          required: 'Address2 field is required',          
        },
        "address[zip]":{
          required: 'Zip field is required',          
        },
        "address[country]":{
          valueNotEquals: 'Country field is required',          
        },
        "address[province]":{
          required: 'Province field is required',          
        },
        "address[city]":{
          required: 'City field is required',          
        },
        "address[phone]":{
          required: 'Phone field is required',          
        }        
      },
      submitHandler: function(form) {
        this.submit();
      }
    });
  
//   newsletter
//   $('form#ContactFooterPopup').validate({
//       rules: {                   
//         "contact[email]": {
//           required: true,
//           email: true,
//         }
//       },
//       messages: {        
//         "contact[email]":{
//         	required: 'Email field is required',
//           	email : 'Enter a valid email'
//         }
//       },
//       submitHandler: function(form) {
//         this.submit();
//       }
//     });
//   $('#footerNewsletter form').validate({
//       rules: {                   
//         "contact[email]": {
//           required: true,
//           email: true,
//         }
//       },
//       messages: {        
//         "contact[email]":{
//         	required: 'Email field is required',
//           	email : 'Enter a valid email'
//         }
//       },
//       submitHandler: function(form) {
//         this.submit();
//       }
//     });
  });
// $(document).ready(function () { 
//   $('#CustomerLogin').click(function(e){
    
//     var error = 1;
//     var password = $('#CustomerPassword').val();
//     var email = $('#CustomerEmail').val();
//     var emailError = $('#CustomerEmailError');
//     var passwordError = $('#CustomerPasswordError');
//     if(email == ''){
//       error = 0;
//     		emailError.text('please enter email');
//     }    
//     if(password == ''){
//       error = 0;
//     		passwordError.text('please enter password');
//     } 
//     console.log('yes');
//     if(!error){
      
//       e.preventDefault();
// //       $('#customer_login').submit();
//     }
//   });


//     $('#customer_login').validate({ // initialize the plugin
  
//         rules: {
//             customer[email]: {
//                 required: true,
//                 email: true
//             },
//             customer[password]: {
//                 required: true,
//                 minlength: 6
//             }
//         }
//     });

// });

// function decrementMinus() {
//   var buttonMinus = $(".cart__qty-input");
//   var amount = Number(buttonMinus.val());
//   if (amount > 0) {
// 		buttonMinus.val(amount-1);
// 	}
// //   $('.cart__qty-input').val(Number($('.cart__qty-input').val())+1 );  
// }

// function incrementPlus() {
//   var buttonPlus  = $(".cart__qty-input");
//   var amount = Number(buttonPlus.val());
//   buttonMinus.val(amount-1);
  
// }

//Customer form ajax call
function saveCustomerInformationabc() {	 
$.ajax({
    xhrFields: {
        withCredentials: true
    },
    headers: {
        'Authorization': 'Basic ' +'ac0431663a8e6ae5ce8dd620103f1dbf:efafe0ca35187635e5fa539d42c7dc28'
//       "X-Shopify-Storefront-Access-Token":"58e245c2426d106e6ff10a846c247c0d",
//       'content-Type':'application/json'
    },
  	type: 'PUT',   
    url: "https://ac0431663a8e6ae5ce8dd620103f1dbf:efafe0ca35187635e5fa539d42c7dc28@salonidev.myshopify.com/admin/api/2019-07/customers/2089994747978.json",
  	data: {"customer":{"first_name":"Hetal12"}},
  	error: function(t) {
      console.log(t);
      console.log('No');
    },
    success: function(response) {
      console.log('Yes');
      console.log(response);
    }
});

//   var settings = {
//     'async': false,
//     'crossDomain': true,
//     'url': 'https://ac0431663a8e6ae5ce8dd620103f1dbf:efafe0ca35187635e5fa539d42c7dc28@salonidev.myshopify.com/admin/api/2019-07/customers/2089994747978.json',
//     'method': 'POST',
//     'headers': {
//         'X-Shopify-Access-Token': 'efafe0ca35187635e5fa539d42c7dc28',
//         'Content-Type': 'application/json',
//     },
//     'data':{"customer":{"first_name":"Hetal12"}},
//     dataType: 'json'
// };

//  $.ajax(settings).done(function (response) {
//     console.log(response);
// });
//         event.preventDefault();
//   		var data ={
//                         "customer": {                                
//                                 "first_name":"Hetal12"
//                         }
//                     };
 
// //         var data = $('#AccountDetail form').serialize();    
//   		$.ajax({
//           type: 'POST',          
//           url: 'https://ac0431663a8e6ae5ce8dd620103f1dbf:efafe0ca35187635e5fa539d42c7dc28@salonidev.myshopify.com/admin/api/2019-07/customers.json',          
//           data: {
//             "customer": {                                
//               "first_name":"Hetal12"
//             }
//           },             
//           dataType: 'json',
//           beforeSend: function (xhr) {
//     			xhr.setRequestHeader (
//                 "X-Shopify-Access-Token":"efafe0ca35187635e5fa539d42c7dc28",
//                 "Content-Type": "application/json" 
//                 );
// 		  },
//           error: function(t) {
//               console.log(t);
//             console.log('No');
//           },
//           success: function(response) {
//             console.log('Yes');
//             console.log(response);
//           }
//         }); 
}

